// Megbeszélés-űrlap tiszta segédei (nem-komponens): a lokalizált zod-hibatérkép. A minta a többi feature
// `form.ts`-e (`buildSupportTeamErrorMap`, `buildContactErrorMap`, …). Külön fájl a komponenstől
// (react-refresh tisztaság + a térkép így önmagában tesztelhető).
import { type TFunction } from 'i18next';
import { type z } from 'zod';

/**
 * LOKALIZÁLT ZOD-HIBATÉRKÉP a megbeszélés-űrlaphoz.
 *
 * ══ MIÉRT KELL ══════════════════════════════════════════════════════════════════════════════════════════
 * A cross-field szabályok (vég > kezdés · munkaidő-ablak · egy online-link) a `refine`-okon SAJÁT i18n-
 * üzenetet hoznak. A MEZŐ-szintű alapszabályok viszont a contract-sémából jönnek (`title`/`locationKey`
 * kötelező), és ott nincs üzenet — így a zod NYERS, ANGOL alapszövege jelent meg a magyar felületen:
 * **„String must contain at least 1 character(s)"** (mérve: üres űrlap mentése a Megbeszélések lapon).
 *
 * ══ MIÉRT `ctx.defaultError` A VISSZAESÉS ═══════════════════════════════════════════════════════════════
 * A `refine`-ok üzenete magán az issue-n érkezik, és a `defaultError` azt hordozza — ha itt egy általános
 * szöveget adnánk vissza minden ismeretlen mezőre, a cross-field szabályok pontos mondatai vesznének el.
 */
export function buildMeetingErrorMap(t: TFunction): z.ZodErrorMap {
  return (issue, ctx) => {
    const field = issue.path[0];
    if (field === 'title') return { message: t('validation:meetings.title') };
    if (field === 'locationKey') return { message: t('validation:meetings.location') };
    return { message: ctx.defaultError };
  };
}
